import { render, staticRenderFns } from "./format12.vue?vue&type=template&id=794d32dc&"
import script from "./format12.vue?vue&type=script&lang=ts&"
export * from "./format12.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports